// A client-side capability gate for whole pages. It mirrors the nav gating so a
// user who types a URL for a page above their role sees a designed
// permission-denied state instead of a broken page. The server is still the
// real authority — this only shapes the UI. W2's management pages wrap their
// content in this.

import type { ReactNode } from "react";
import { IconLock } from "@tabler/icons-react";
import type { ServerRole } from "../api";
import { useUser } from "../session";
import { hasServerRole } from "./roles";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

export function RequireRole({
  min,
  children,
}: {
  min: ServerRole;
  children: ReactNode;
}) {
  const user = useUser();
  if (hasServerRole(user.server_role, min)) return <>{children}</>;
  return (
    <div className="p-6">
      <Empty className="border">
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <IconLock />
          </EmptyMedia>
          <EmptyTitle>You don't have access to this area</EmptyTitle>
          <EmptyDescription>
            This section needs a {min} role. You're signed in as {user.server_role}. Ask a server
            admin if you think this is a mistake.
          </EmptyDescription>
        </EmptyHeader>
      </Empty>
    </div>
  );
}
